import './Assets/Css/Style.css'
import TipCalculator from "./Components/TipCalculator.js";

function App() {
  return (
    <div className="App"> 
      <TipCalculator />
    </div> 
  );
}

export default App;
